/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'underscore',
        'assets/js/backbone-extended',
        'assets/js/modules/product/model/designerModel',
        'assets/js/modules/product/model/attributeModel',
        'assets/js/modules/product/model/skuModel',
        'assets/js/modules/product/model/startFileModel',
        'assets/js/modules/option/optionModel',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/product/model/productSampleModel'
    ],
    function(
        _,
        backboneExtended,
        DesignerModel,
        AttributeModel,
        SkuModel,
        StartFileModel,
        OptionModel,
        OptionValueModel,
        ProductSampleModel
    ) {
        var ALERT_OPTION_VALUE_NAMES = ['none_trimming'];

        return backboneExtended.NestedModel.extend(
            {
                idAttribute: 'slug',
                defaults: {
                    slug: null,
                    name: null,
                    enabled: true,
                    defaultImage: null,
                    designers: new backboneExtended.Collection(),
                    attributes: new backboneExtended.Collection(),
                    options: new backboneExtended.Collection(),
                    skus: new backboneExtended.Collection(),
                    startFiles: new backboneExtended.Collection(),
                    samples: new backboneExtended.Collection()
                },

                /**
                 * @param {string} name
                 * @returns {string|undefined}
                 */
                getAttribute: function(name) {
                    return this.get('attributes').findWhere({ name: name });
                },

                /**
                 * @param {string} name
                 * @returns {string|null}
                 */
                getAttributeValue: function(name) {
                    var attr = this.get('attributes').findWhere({ name: name });
                    if (attr) {
                        return attr.getValue();
                    }
                    return null;
                },

                /***
                 * @param {Object} dto
                 * @returns {ProductModel}
                 */
                fromDTO: function(dto) {
                    if (dto.slug) {
                        this.set('slug', dto.slug);
                    }

                    if (dto.name) {
                        this.set('name', dto.name);
                    }

                    if (dto.enabled !== undefined) {
                        this.set('enabled', dto.enabled);
                    }

                    if (dto.default_image !== undefined) {
                        this.set('defaultImage', dto.default_image);
                    }

                    if (dto.designers && dto.designers.length) {
                        var designers = new backboneExtended.Collection();
                        _.each(dto.designers, function(designerDTO) {
                            designers.add(new DesignerModel().fromDTO(designerDTO));
                        });
                        this.set('designers', designers);
                    }

                    if (dto.attributes && dto.attributes.length) {
                        var attributes = new backboneExtended.Collection();
                        _.each(dto.attributes, function(attributeDTO) {
                            attributes.add(new AttributeModel().fromDTO(attributeDTO));
                        });
                        this.set('attributes', attributes);
                    }

                    if (dto.skus && dto.skus.length) {
                        var skus = new backboneExtended.Collection();
                        _.each(dto.skus, function(skuDTO) {
                            if (skuDTO.enabled) {
                                skus.add(new SkuModel().fromDTO(skuDTO));
                            }
                        });
                        this.set('skus', skus);
                    }

                    if (dto.start_files && dto.start_files.length) {
                        var startFiles = new backboneExtended.Collection();
                        _.each(dto.start_files, function(startFileDTO) {
                            startFiles.add(new StartFileModel().fromDTO(startFileDTO));
                        });
                        this.set('startFiles', startFiles);
                    }

                    if (dto.options && dto.options.length) {
                        var options = new backboneExtended.Collection();
                        _.each(dto.options, function(optionDTO) {
                            var optionValues = new backboneExtended.Collection();
                            _.each(optionDTO.option_values, function(optionValueDTO) {
                                if (optionValueDTO.enabled) {
                                    var optionValue = new OptionValueModel().fromDTO(optionValueDTO);
                                    optionValue.set({
                                        isAlert: ALERT_OPTION_VALUE_NAMES.indexOf(optionValueDTO.name) !== -1
                                    });
                                    optionValues.add(optionValue);
                                }
                            });
                            var option = new OptionModel().fromDTO(optionDTO);
                            option.set({
                                optionValues: optionValues
                            });
                            options.add(option);
                        });
                        this.set('options', options);
                    }

                    if (dto.samples && dto.samples.length) {
                        var samples = new backboneExtended.Collection();
                        _.each(dto.samples, function(samplesDTO) {
                            samples.add(new ProductSampleModel().fromDTO(samplesDTO));
                        });
                        this.set('samples', samples);
                    }

                    return this;
                },

                /**
                 * @param {string} optionValueName
                 * @returns {OptionValueModel|undefined}
                 */
                getOptionValueByName: function(optionValueName) {
                    var foundOptionValue;
                    this.get('options').find(function(option) {
                        return option.get('optionValues').find(function(optionValue) {
                            if (optionValue.get('name') === optionValueName) {
                                foundOptionValue = optionValue;
                            }
                        });
                    });

                    return foundOptionValue;
                },

                /**
                 * @param {string} optionValueName
                 * @returns {boolean}
                 */
                hasOptionValue: function(optionValueName) {
                    return this.getOptionValueByName(optionValueName) !== undefined;
                },

                /**
                 * @returns {[]}
                 */
                getDefaultOptionValueNames: function() {
                    return this.get('options').reduce(function(names, option) {
                        var defaultOptionValue = option.get('optionValues').findWhere({ default: true });
                        if (defaultOptionValue) {
                            names.push(defaultOptionValue.get('name'));
                        }
                        return names;
                    }, []);
                },

                /**
                 * @return {boolean}
                 */
                hasSamples: function() {
                    return this.get('samples').length > 0;
                },

                isBooklet: function() {
                    return (
                        [
                            'booklets-55x85',
                            'booklets-85x11',
                            'booklets-a6-portrait',
                            'booklets-a6-landscape',
                            'booklets-a5-portrait',
                            'booklets-a5-landscape',
                            'booklets-a4-portrait'
                        ].indexOf(this.get('slug')) !== -1
                    );
                }
            },
            {
                SLUG_PF: 'pf'
            }
        );
    }
);
